export const DATA_COMPILATION_TEMPLATE =
  'https://cdn.getsave.io/templates/data-compilation-template.xlsx';
export const DATA_COLLECTION_TEMPLATE =
  'https://cdn.getsave.io/templates/data-collection-template.pdf';
export const CREDIT_USER_TEMPLATE =
  'https://cdn.getsave.io/templates/credit-user-template.xlsx';
export const CREDIT_GROUP_TEMPLATE =
  'https://cdn.getsave.io/templates/credit-group-template.xlsx';
